define('home/templates/editDiscussionCategory',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : {};

  return "<label class=\"align spacing-narrow\">\n<div class=\"align__item spacing-right\">\n<input type=\"radio\" name=\"category\" value=\""
    + alias2(alias1((data && data.key), depth0))
    + "\" alt=\""
    + alias2(alias1(depth0, depth0))
    + "\" "
    + ((stack1 = helpers["if"].call(alias3,helpers.eq.call(alias3,(data && data.key),(depths[1] != null ? depths[1].category : depths[1]),{"name":"eq","hash":{},"data":data}),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " />\n</div>\n<div class=\"spacing-bottom-small align__item text-medium text-gray-darker\">\n"
    + alias2(alias1((data && data.key), depth0))
    + "\n<p class=\"text-gray\">\n"
    + alias2(alias1(depth0, depth0))
    + "\n</p>\n</div>\n</label>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "checked";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<h3 class=\"text-gray-darker\">\n"
    + alias2(helpers.gettext.call(alias1,"Choose Category",{"name":"gettext","hash":{},"data":data}))
    + "\n<span data-toggle=\"tooltip\" data-placement=\"bottom\"\ntitle=\""
    + alias2(helpers.gettext.call(alias1,"%(channelTitle)s requires that you choose a category to guide your discussion. This helps maintain a common theme throughout discussions on this channel.",{"name":"gettext","hash":{"channelTitle":(depth0 != null ? depth0.name : depth0)},"data":data}))
    + "\">\n<span class=\"icon-questions icon__position icon-tiny text-gray\"></span>\n</span>\n</h3>\n<div data-role=\"attribute-error\" class=\"form-message-error text-small spacing-default\"></div>\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.categories : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"useData":true,"useDepths":true})

});
